import { readResult } from "@/data/read-result";
import {
  readPlayShell,
  readPlayActivity,
  readPlayEpisodes,
  readPlayRequests,
} from "./play-data";
import { readPlayDestination } from "./data/play-destination";

type PlayRead = { data: { href: string }; signal?: AbortSignal | undefined };

export function getPlayShell({ data, signal }: PlayRead) {
  return readResult(() => readPlayShell({ href: data.href, signal }));
}

export function getPlayActivity({ data, signal }: PlayRead) {
  return readResult(() => readPlayActivity({ href: data.href, signal }));
}

export function getPlayEpisodes({ data, signal }: PlayRead) {
  return readResult(() => readPlayEpisodes({ href: data.href, signal }));
}

export function getPlayRequests({ data, signal }: PlayRead) {
  return readResult(() => readPlayRequests({ href: data.href, signal }));
}

export function getPlayDestination({
  signal,
}: { signal?: AbortSignal | undefined } = {}) {
  return readPlayDestination({ signal });
}
